<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      size="mini"
      resizable
      cell-class-name="align-top"
    >
      <template v-slot:showFiles="{ row }">
        <span>
          {{ row.v_docFileType }}
        </span>
        <br />
        <span>
          {{ row.fileName }}
        </span>
        <br />
        <span>
          {{ row.docRemark }}
        </span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      default: () => []
    }
  },
  data() {
    return {
      data: [],
      loading: false,
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: '操作',
          headerAlign: 'center',
          align: 'center',
          width: 50,
          slots: {
            default: 'opt'
          }
        },
        {
          field: 'fileName',
          headerAlign: 'center',
          align: 'left',
          minWidth: 200,
          title: '文档名称',
          slots: {
            default: 'showFiles'
          }
        }
      ]
    }
  },
  created() {},
  methods: {
    downloadFile({ fileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    }
  }
}
</script>
